import React from "react";
import useI18n from "../hooks/useI18n.js";
import { useAutoplayError } from "@100mslive/react-sdk";
import { Button, Dialog, Text } from "@100mslive/roomkit-react";
import { DialogContent, DialogRow } from "../../primitives/DialogContent";

export function AutoplayBlockedModal() {
  const { error, resetError, unblockAudio } = useAutoplayError();
  const { t } = useI18n("common");
  return (
    <Dialog.Root
      open={!!error}
      onOpenChange={value => {
        if (!value) {
          unblockAudio();
        }
        resetError();
      }}
    >
      <DialogContent title={t("permission_error")} closeable={false}>
        <DialogRow>
          <Text variant="md">
            {t("autoplay_blocked_message")}
            <br />
            {t("please_allow_audio")}
          </Text>
        </DialogRow>
        <DialogRow justify="end">
          <Button
            variant="primary"
            onClick={() => {
              unblockAudio();
              resetError();
            }}
          >
            {t("allow_audio")}
          </Button>
        </DialogRow>
      </DialogContent>
    </Dialog.Root>
  );
}
